module.exports = __webpack_public_path__ + "static/media/classroom-img.64ba118f.png";